import React from 'react';
import { Link } from 'react-router-dom';
import { error1, dangericon } from '../imagepath';

const NotFound = () => {
  return (
    <div className="main-wrapper error-wrapper">
      <div className="error-box">
        <img className="img-fluid" src={error1} alt="404 Error" />
        <h3>
          <img
            className="img-fluid mb-0"
            src={dangericon}
            alt="Error Icon"
          />
          404 - Страницата не е намерена
        </h3>
        <p>Страницата, която търсите, не съществува или е била преместена.</p>
        <Link to="/admin-dashboard" className="btn btn-primary go-home">
          Върни се към началото
        </Link>
      </div>
    </div>
  );
};

export default NotFound;